import { VerticalBlockAlignType, AnimationSequenceType } from "common/constants";
import { FormatType } from "common/constants.js";
import { TextGroup } from "js/elements/base/TextGroup";
import { RadialBarGraph } from "js/elements/elements/infographics/RadialBarGraph";
import { HorizontalAlignType } from "common/constants";
import CompareValuesItem from "./CompareValuesItem";
import CompareValuesItemLabel from "./CompareValuesItemLabel";

export default class CompareRadialBarItem extends CompareValuesItem {
    _build() {
        this.radialBar = this.addElement("radialBar", () => RadialBarGraph, {
            showLabel: this.parentElement.format != FormatType.NONE,
            valueFunction: () => this.percentageValue,
            labelElement: CompareValuesItemLabel
        });
        this.text = this.addElement("text", () => TextGroup, {
            autoHeight: true
        });
    }

    _calcProps(props, options) {
        let { size, children, styles } = props;

        let layouter = this.getLayouter([this.radialBar, this.text], size);
        if (options.orientation == "vertical") {
            layouter.calcVerticalBlockLayout({
                contentSize: size.square(),
                horizontalAlign: HorizontalAlignType.CENTER
            });
        } else {
            layouter.calcHorizontalBlockLayout({
                verticalAlign: VerticalBlockAlignType.MIDDLE_OR_TOP
            });
        }
        this.isTextFit = layouter.isTextFit;

        return { size: layouter.size };
    }

    get buildAnimations() {
        const radialBarAnimations = this.radialBar.buildAnimations;
        return [...radialBarAnimations, {
            type: AnimationSequenceType.FADE,
            target: this.text.DOMNode,
            delay: duration => duration - 400
        }];
    }
}
